module.exports = __webpack_public_path__ + "static/img/mark4.85fd397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/markdown/mark4.png
// module id = A95Q
// module chunks = 0